import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  locations: [],
  location: {}
}

export const mutations = {
  SET_LOCATIONS(state, locations) {
    state.locations = locations
  },
  SET_LOCATION(state, location) {
    state.location = location
  },
  ADD_LOCATION(state, location) {
    state.locations.push(location)
  },
  EDIT_LOCATION(state, location) {
    const index = state.locations.findIndex(
      el => el.company_location_uuid === location.company_location_uuid
    )
    if (index !== -1) {
      state.locations.splice(index, 1, location)
    }
  },
  DELETE_LOCATION(state, company_location_uuid) {
    const index = state.locations.findIndex(
      el => el.company_location_uuid === company_location_uuid
    )
    if (index !== -1) state.locations.splice(index, 1)
  }
}

export const actions = {
  fetchLocations({ commit }, company_uuid) {
    return ApiService.fetchLocations(company_uuid)
      .then(res => {
        const locations = res.data.data
        commit('SET_LOCATIONS', locations)
      })
      .catch(error => {
        throw error
      })
  },
  fetchLocation({ commit, getters, state }, id) {
    if (state.location.company_location_id === id) {
      return state.location
    }

    const location = getters.getLocationById(id)

    if (location) {
      commit('SET_LOCATION', location)
      return location
    } else {
      return ApiService.fetchLocation(id)
        .then(res => {
          const location = res.data
          commit('SET_LOCATION', location)
          return location
        })
        .catch(error => {
          throw error
        })
    }
  },
  addLocation({ commit }, payload) {
    return ApiService.addLocation(payload)
      .then(res => {
        const location = res.data
        commit('ADD_LOCATION', location)
      })
      .catch(error => {
        throw error
      })
  },
  editLocation({ commit }, payload) {
    return ApiService.editLocation(payload)
      .then(res => {
        const location = res.data
        commit('EDIT_LOCATION', location)
      })
      .catch(error => {
        throw error
      })
  },
  deleteLocation({ commit }, payload) {
    return ApiService.deleteLocation(payload)
      .then(() => {
        commit('DELETE_LOCATION', payload.company_location_uuid)
      })
      .catch(error => {
        throw error
      })
  }
}

export const getters = {
  getLocationById: state => id => {
    return state.locations.find(el => el.company_location_id === id)
  }
}
